<template>
  <div>
    <van-nav-bar title="登录"></van-nav-bar>
    <van-form @submit="onSubmit">
      <van-field
        v-model="openId"
        name="openId"
        label="openId"
        placeholder="请输openId"
        :rules="[{ required: true, message: '内容不能为空' }]"
      />
      <div style="margin: 16px">
        <van-button round block type="info" native-type="submit"
          >提交</van-button
        >
      </div>
    </van-form>
  </div>
</template>
<script>
export default {
  data() {
    return {
      openId: '',
    }
  },
  methods: {
    onSubmit(values) {
      sessionStorage.setItem('openId', this.openId)
      this.$router.push('/')
    },
  },
}
</script>
<style scoped lang="scss">
.avaterImg {
  width: 30px;
  height: 30px;
  border-radius: 50%;
}
/deep/.van-form {
  margin: 30px 10px 0;
}
/deep/.van-cell {
  border: 1px solid #ccc;
}
/deep/.van-cell::after {
  border-bottom: none;
}
</style>